@if (named) {
  <a class="environment-pill" [style.--environment-hue]="hue" [href]="link" target="_blank" rel="noopener">{{ environment?.label }}</a>
} @else {
  -
}
